import React, { Component, } from 'react';
import { render } from 'react-dom';

import { Player } from './timeline-player';
import { SecondScreen } from './second-screen';
import { Overview } from './overview';
import { About } from './about';
import { isMobile } from './utils';

class App extends Component {
    constructor(props) {
        super(props);
        this.MODES = ['p', 'e', 's', 'f', 'about']

        this.state = {
            isPlayer: this.isPlayer(),
            project: this.getProject(),
            yaml: this.getYaml(),
            startTime: this.getStartTime()
        }
        this.onHashChange = this.onHashChange.bind(this);
        window.addEventListener('hashchange', this.onHashChange, false);
        window.app = this
    }

    isPlayer() {
        return ['p', 'f'].indexOf(this.getMode()) > -1
    }

    getPath() {
        var path = document.location.hash.slice(1)
        if (!path.length && document.location.pathname !== '/preview.html') {
            path = document.location.pathname.slice(1)
        }
        return path
    }

    getMode() {
        var project = this.getPath()
        var mode = project.split('/')
        if (this.MODES.indexOf(mode[0]) > -1) {
            mode = mode[0]
        } else {
            mode = 'p'
        }
        return mode
    }

    parseTime(pos) {
        var t
        var parts = pos.split(':')
        if (parts.length > 1) {
            return parts.reverse().map(p => {
                return parseFloat(p)
            }).reduce( (result, value, idx) => {
                result = result || 0
                return result + (value * 60**idx)
            })
        } else {
            t = parseFloat(pos)
        }
        return t
    }

    getProject() {
        var project = this.getPath()
        var mode = project.split('/')
        if (this.MODES.indexOf(mode[0]) > -1) {
            project = mode.slice(1).join('/')
        }
        if (project.split('/').length == 2) {
            var parts = project.split('/')
            var position = this.parseTime(parts[parts.length -1])
            if (!isNaN(position)) {
                project = parts[0]
            }
        }
        return project
    }

    getPosition() {
        var project = this.getPath()
        var mode = project.split('/')
        if (this.MODES.indexOf(mode[0]) > -1) {
            project = mode.slice(1).join('/')
        }
        if (project.split('/').length == 2) {
            var parts = project.split('/')
            var position = parts[parts.length -1]
            return this.parseTime(position)
        }
    }

    getStartTime() {
        var pos = this.getPosition()
        if (!isNaN(pos)) {
            history.replaceState(null, null, document.location.hash.split('/').slice(0, -1).join('/'));
            return pos
        }
        var t = parseFloat(localStorage[this.getProject() + '_currentTime'] || 0)
        t = isNaN(t) ? 0 : t
        return t
    }

    getYaml() {
        var project = this.getProject(),
            yaml;
        if (project.length) {
            yaml = '/project/' + project + '/timeline.yaml'
        }
        return yaml
    }
    onHashChange() {
        var project = this.getProject()
        if (project && isMobile() && ! document.fullscreen) {
            document.body.requestFullscreen()
        }
        this.setState({
            isPlayer: this.isPlayer(),
            project: project,
            yaml: this.getYaml(),
            hashChange: true
        })
    }
    render() {
        var className = 'editor'
        var broadcast = false
        var autoplay = false
        var loop = false
        var home = false
        var about = false
        var mode = this.getMode()
        if (mode === 'p') {
            className = 'player-box'
            if (this.state.hashChange) {
                autoplay = true
            }
            home = true
        } else if (mode === 'f') {
            className = 'player-box'
            mode = 'p'
            broadcast = true
            autoplay = true
            loop = true
        } else if (mode === 's') {
            className = 'second'
        }
        if (mode === 'about') {
            about = true
            document.body.classList.add('about-page')
        } else {
            document.body.classList.remove('about-page')
        }
        return this.state.yaml ? mode === 's' ? (
            <div className={className}>
                <SecondScreen
                    yaml={this.state.yaml}
                    project={this.state.project}
                    startTime={this.state.startTime}
                    key={this.state.yaml} />
            </div>
        ) : (
            <div className={className}>
                <Player timeline={!this.isPlayer()}
                        yaml={this.state.yaml}
                        project={this.state.project}
                        startTime={this.state.startTime}
                        key={this.state.yaml}
                        broadcast={broadcast}
                        autoplay={autoplay}
                        loop={loop}
                        home={home}
                />
            </div>
        ) : about ? (
            <About />
        ) : (
            <Overview />
        );
    }
}

render(<App />, document.getElementById('root'));
